import { Form, Input } from "antd";
import { useTranslation } from "react-i18next";

/**
 * Generic search form criteria to be made specific form each resource
 * */
export const GenericSearchFormCriteria = () => {
    const { t } = useTranslation();

    return (
        <>
            <Form.Item label={t("form.name")} name="name">
                <Input type="text" />
            </Form.Item>
            <Form.Item label={t("form.system.id")} name="id">
                <Input type="number" min={1} />
            </Form.Item>
        </>
    );
};
